import { useState } from "react";

import { Button, Card, Divider, Grow, Icon, List, ListItem, Popper, Stack, Typography } from "@mui/material";

import { OPERATIONS } from "Constants/Operations";
import { OperationNames } from "Types/operation";
import { StationType } from "Types/station";

import { useAppDispatch, useAppSelector } from "Hooks/useRedux";

import { changeOperation } from "Redux/operationSlice";
import { toggleVisibility } from "Redux/filtersSlice";
import { toggleVisibility as togglePaths } from "Redux/servicesSlice";
import { toggleVisibility as toggleStations } from "Redux/stationsSlice";

interface IProps {
  animation: (isActive: boolean) => {};
}

const ItemsTextStyle = {
  color: "#000",
  fontSize: "16px",
};

export default function Operations({ animation }: IProps) {
  const dispatch = useAppDispatch();
  const { name } = useAppSelector((state) => state.operation);
  const { visible: stationsVisibility } = useAppSelector((state) => state.stations);
  const { visible: servicesVisibility } = useAppSelector((state) => state.services);

  const isActive = name === null;

  const [activeMenuIndex, setActiveMenuIndex] = useState<null | number>(null);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  // Logic functions
  const handleClick = (event: React.MouseEvent<HTMLElement>, index: number) => {
    const { currentTarget } = event;

    if (activeMenuIndex === index) {
      setActiveMenuIndex(null);
      return;
    }
    if (activeMenuIndex === null) {
      setAnchorEl(currentTarget);
      setActiveMenuIndex(index);
    } else {
      setActiveMenuIndex(null);
    }

    setTimeout(() => {
      setAnchorEl(currentTarget);
      setActiveMenuIndex(index);
    }, 250);
  };
  const handleClickType = (operationName: OperationNames, type: StationType) => {
    dispatch(changeOperation({ name: operationName, type }));
    if (!stationsVisibility) {
      dispatch(toggleStations());
    }

    // if (operationName === "station-timing" && !servicesVisibility) {
    //   dispatch(togglePaths());
    // }

    setActiveMenuIndex(null);
  };

  // UI functions
  const renderMenuItems = () =>
    OPERATIONS.map((operation, index) => {
      return (
        <div key={operation.name}>
          <Button
            sx={{
              ...ItemsTextStyle,
              bgcolor: activeMenuIndex === index ? "#F2F2F2" : "",
              "&:hover": { bgcolor: activeMenuIndex === index ? "#F2F2F2" : "" },
            }}
            variant="white"
            size="large"
            aria-describedby={`item-${index}`}
            type="button"
            onClick={(e) => handleClick(e, index)}
          >
            <Icon sx={{ mr: 1 }}>{operation.icon}</Icon>
            {operation.text}
          </Button>

          <Popper id={`item-${index}`} open={index === activeMenuIndex} anchorEl={anchorEl} placement="bottom-start" transition>
            {({ TransitionProps }) => (
              <Grow {...TransitionProps}>
                <Card sx={{ mt: 1 }}>
                  <List component="nav" sx={{ p: 0 }}>
                    {operation.types.map((type, typeIndex) => {
                      return (
                        <>
                          <ListItem
                            button
                            sx={{ py: 2, px: 3, minWidth: "250px" }}
                            onClick={() => handleClickType(operation.name, type.type)}
                          >
                            <Stack direction="row" spacing={1} alignItems="center">
                              {type.icon}
                              <Typography sx={ItemsTextStyle}>مسیر {type.text}</Typography>
                            </Stack>
                          </ListItem>
                          {typeIndex + 1 < operation.types.length && <Divider />}
                        </>
                      );
                    })}
                  </List>
                </Card>
              </Grow>
            )}
          </Popper>
        </div>
      );
    });

  return (
    <Stack direction="row" spacing={1} sx={animation(isActive)}>
      {/* {renderMenuItems()} */}
    </Stack>
  );
}
